import {Box, Button, TextField, Typography, useTheme} from "@mui/material";
import {useSearchContext} from "../../../../Contexts/SearchContext";
import {useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import postsService from "../../../../Services/PostsService";
import {formatNumber, formatZip, isValidZip} from "../../../../Utilities/postUtils";
import {CustomPopper} from "../../../Shared/Shared";
import Column from "../../../Common/Column";
import Space from "../../../Common/Space";
import Row from "../../../Common/Row";
import {FilterBoxMobile} from "./FilterBoxMobile";


export const LocationFilterMobile = () => {
    const theme = useTheme();
    const searchContext = useSearchContext();

    const [searchParams, setSearchParams] = useSearchParams();
    const latLngParam = searchParams.get("latLng");
    const radiusParam = searchParams.get("radius");

    const isActive = latLngParam != null && radiusParam != null

    const [anchorEl, setAnchorEl] = useState(null);

    const anchorRef = React.useRef();
    const open = Boolean(anchorEl);

    const [radius, setRadius] = useState(radiusParam ?? "");
    const [zipCode, setZipCode] = useState("");
    const hasValue = radius !== "" || zipCode !== "";

    useEffect(() => {
        if (open == false) return;

        setRadius(radiusParam ?? "")
    }, [radiusParam, open]);

    useEffect(() => {
        if (open == false) return;

        if (latLngParam == null) {
            setZipCode("");
            return;
        }

        const latLng = latLngParam?.split(",");
        const lat = latLng[0];
        const lng = latLng[1];

        postsService.latLngToZipCode(lat, lng)
            .then((zip) => {
                // If the conversion was successful
                if (isValidZip(zip)) {
                    setZipCode(zip);
                }
            });
    }, [latLngParam, open]);

    const handleOpen = () => {
        setAnchorEl(anchorRef.current);
    }

    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleSave = async () => {
        await searchContext.refineRadiusAndZipCode(radius, zipCode);
        handleClose();
    }

    const handleReset = () => {
        setRadius("");
        setZipCode("");
    }

    const handleRadiusChange = (event) => {
        setRadius(formatNumber({
            value: event.target.value,
            maxLength: 4,
            excludeZero: true,
            useComma: false
        }));
    }

    const handleZipCodeChange = (event) => {
        setZipCode(formatZip(event.target.value));
    }

    return <React.Fragment>
        <FilterBoxMobile
            title={"Lokation"}
            numberOfActiveFilters={isActive ? 1 : 0}
            onOpen={handleOpen}
            anchorRef={anchorRef}
        />
        <CustomPopper
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
        >
            <React.Fragment>
                <Column sx={{display: "flex", justifyContent: "end"}}>
                    <Typography
                        sx={{
                            width: "fit-content",
                            fontWeight: hasValue ? "bold" : "normal",
                            color: hasValue ? theme.palette.jagtred.main : "grey",
                            cursor: hasValue ? "pointer" : "default",
                            pointerEvents: hasValue ? "auto" : "none",
                        }}
                        onClick={handleReset}
                    >
                        Nulstil
                    </Typography>
                </Column>
                <Space height="10px"/>
                <Row sx={{alignItems: "center"}}>
                    <TextField
                        sx={{maxWidth: "100px"}}
                        label={"Km"}
                        value={radius}
                        onChange={handleRadiusChange}
                    />
                    <Typography
                        sx={{padding: "0 5px"}}
                    >fra</Typography>
                    <TextField
                        sx={{maxWidth: "100px"}}
                        label={"Postnr."}
                        value={zipCode}
                        onChange={handleZipCodeChange}
                    />
                </Row>
                <Space height="15px"/>
                <Box sx={{textAlign: "end"}}>
                    <Button
                        variant="contained"
                        color="jagtred"
                        sx={{margin: "0 0 10px 0"}}
                        onClick={handleSave}
                    >
                        Gem
                    </Button>
                </Box>
            </React.Fragment>
        </CustomPopper>

    </React.Fragment>
}